import styled, { css } from 'styled-components'
import { colors } from '../../../../../../../styles/constants'

const standardText = css`
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  color: ${colors.gray.dark};
`

export const Content = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;

  strong {
    font-family: 'Open Sans';
    font-weight: 600;
  }
`

export const DetailedInfo = styled.div`
  ${standardText}
`

export const Label = styled.div`
  ${standardText}
  padding: 2px 8px 3px;
  border-radius: 8px;
  background-color: ${colors.gray.lighter};
  order: 3;
  margin: 16px 0;
  width: fit-content;
  ${({ value, maxData }) => value === maxData && css`
    color: ${colors.cyan.default};
    background-color: ${colors.cyan.light};
  `}
`
